import { render, staticRenderFns } from "./registrarManage.vue?vue&type=template&id=9774bfd6&scoped=true&"
import script from "./registrarManage.vue?vue&type=script&lang=js&"
export * from "./registrarManage.vue?vue&type=script&lang=js&"
import style0 from "./registrarManage.vue?vue&type=style&index=0&id=9774bfd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9774bfd6",
  null
  
)

export default component.exports